import React from 'react';

import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import CookiePolicy from '../components/CookiePolicy/CookiePolicy';
import Footer from '../components/Footer/Footer';

import BgDesktopSrc from '../images/hero-fire-bg-desktop.jpg';
import BgMobileSrc from '../images/hero-fire-bg-mobile.jpg';
import SEO from '../components/SEO/SEO';

const TermsPage = () => {
  return (
    <>
      <SEO pageName="contacookiect" />
      <div
        style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}
      >
        <Header />
        <main id="main" tabIndex="-1">
          <Hero
            img={{ mobile: BgMobileSrc, desktop: BgDesktopSrc }}
            title="cookie&nbsp;&amp;&nbsp;policy"
          />
          <CookiePolicy />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default TermsPage;
